import { createSlice } from '@reduxjs/toolkit'
import type { PayloadAction } from '@reduxjs/toolkit'

export interface SurveyState {
  preSurveyId: string | null
  postSurveyId: string | null
  post90SurveyId: string | null
  loaded: boolean
}

export const surveyInitialState: SurveyState = {
  preSurveyId: null,
  postSurveyId: null,
  post90SurveyId: null,
  loaded: false
}

export const surveySlice = createSlice({
  name: 'survey',
  initialState: surveyInitialState,
  reducers: {
    setSurveyIds: (state, action: PayloadAction<{ preSurveyId: string, postSurveyId: string, post90SurveyId: string }>) => {
      state.preSurveyId = action.payload.preSurveyId
      state.postSurveyId = action.payload.postSurveyId
      state.post90SurveyId = action.payload.post90SurveyId
      state.loaded = true
    }
  }
})

export const {
  setSurveyIds
} = surveySlice.actions

export default surveySlice.reducer
